import React, { useEffect, useRef } from "react";
import { animate, stagger } from "motion";

interface WavyTextProps {
  text: string;
}

const WavyText: React.FC<WavyTextProps> = ({ text }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const chars = Array.from(
      containerRef.current.querySelectorAll(".wavy-char")
    );

    animate(
      chars,
      { y: [-20, 20] },
      {
        repeat: Infinity,
        repeatType: "mirror",
        ease: "easeInOut",
        duration: 2,
        delay: stagger(0.15, {
          startDelay: -0.15 * chars.length,
        }),
      }
    );
  }, []);

  return (
    <div className="wavy-container" ref={containerRef}>
      {text.split("").map((char, index) => (
        <span
  key={index}
  className="wavy-char inline-block mx-[3px]" // Adjust spacing here
>

          {char}
        </span>
      ))}
      <style>{`
        .wavy-container {
          display: inline-block;
        }
        .wavy-char {
          display: inline-block;
          will-change: transform;
        }
      `}</style>
    </div>
  );
};

export default WavyText;
